import React from "react";

import styles from "./HotelViewToggle.module.css";

const HotelViewToggle = ({
  viewMode,
  onChange,
}) => {

  return (
    <div className={styles.toggle}>

      <button
        type="button"
        className={
          viewMode === "grid"
            ? styles.active
            : ""
        }
        onClick={() =>
          onChange("grid")
        }
        aria-label="Grid view"
      >
        ▦
        <span>Grid</span>
      </button>


      <button
        type="button"
        className={
          viewMode === "list"
            ? styles.active
            : ""
        }
        onClick={() =>
          onChange("list")
        }
        aria-label="List view"
      >
        ☰
        <span>List</span>
      </button>
{/* 
      <button
  type="button"
  className={
    viewMode === "map"
      ? styles.active
      : ""
  }
  onClick={() =>
    onChange("map")
  }
  aria-label="Map view"
>
  📍
  <span>Map</span>
</button> */}
<button
  type="button"
  className={
    viewMode === "map"
      ? styles.active
      : ""
  }
  onClick={() => {
    console.log("MAP BUTTON CLICKED");
    onChange("map");
  }}
  aria-label="Map view"
>
  📍
  <span>Map</span>
</button>
    </div>
  );
};

export default HotelViewToggle;